export default {
    validate(ctx) {
        if(ctx.params.category == 'set'){
            return false;
        }
        if(ctx.params.category != 'cars'){
            return false
        }
        if(ctx.route.name == 'category-mark'){
            let marks = ctx.store.getters['marks/marks/markFolderGeneration']
            let setFolder = marks.find(item => item.slug === ctx.params.mark)
            let arrSet = ctx.store.getters['marks/marks/arrSet'];
            if(arrSet.includes(ctx.params.mark)){
                return true;
            }
            if(!setFolder){
                return false;
            }
            }
           if(ctx.route.name == 'category-mark-model'){
            let marks = ctx.store.getters['marks/marks/markFolderGeneration']
            let setFolder = marks.find(item => item.slug === ctx.params.mark)
            if(!setFolder){
                return false;
            }
            let setGeneration = null
            if(setFolder?.folders){
                setGeneration = setFolder?.folders?.find(item => item.slug === ctx.params.model)
            }
            if(!setGeneration){
                return false;
            }
        }
         if(ctx.route.name == 'category-mark-model-car'){
            let marks = ctx.store.getters['marks/marks/markFolderGeneration']
            let setFolder = marks.find(item => item.slug === ctx.params.mark)
            if(!setFolder){
                return false;
            }
            let setGeneration = null
            if(setFolder?.folders){
                setGeneration = setFolder?.folders?.find(item => item.slug === ctx.params.model)
            }
            if(!setGeneration){
                return false;
            }
            let setGenerationOver = null
            if(setGeneration.generations){
                setGenerationOver = setGeneration?.generations?.find(item => item.slug === ctx.params.car)
            }

            if(setGenerationOver || Number(ctx.params.car)){
                return true
            }else{
                return false
            }
        }
        return true;
    }
}
